import React, { useState } from "react";
import Messages from "./Messages";
import TimesheetInitial from "./TimesheetInitial";
import { useCommonTimesheetProvider } from "../../../../Providers/Common/Timesheet";
import TimesheetPdf from "../../../../Components/TimesheetPdf";
import { pdf } from "@react-pdf/renderer";
import { Button, Switch } from "antd";
import { Modal, Space, DatePicker } from "antd";
import dayjs from "dayjs";
import SimpleBackdrop from "../../../../Components/SimpleBackDrop";
import { useParams } from "react-router-dom";

const { RangePicker } = DatePicker;
export default function MessageSummary({ jobId, setShowTimesheetDetails }) {
  const activeTab = "Summary";
  const [downloadPdfModalToggle, setDownloadPdfModalToggle] = useState(false);
  const [timesheetSummary, setTimesheetSummary] = useState(false)
  const [startEndDate, setStartEndDate] = useState([]);
  const { fetchTimesheetByWeek, downloadTimesheetasPdf, loading } =
    useCommonTimesheetProvider();
  const [timesheets, setTimesheets] = useState([]);

  const onChangeSummary = () => {
    setTimesheetSummary(!timesheetSummary)
  };

  const { id } = useParams()

  async function downloadPdf() {
    const timesheet = await fetchTimesheetByWeek(
      id,
      startEndDate[0],
      startEndDate[1]
    );
    if (!timesheet || timesheet?.length === 0) return;
    const doc = <TimesheetPdf data={timesheet} timesheetSummary={timesheetSummary} />;
    const asPdf = pdf([]);
    asPdf.updateContainer(doc);
    const blob = await asPdf.toBlob();

    // download the blob
    downloadTimesheetasPdf(blob, startEndDate[0], startEndDate[1]);
  }
  return (
    <div className="mt-8">
      <SimpleBackdrop open={loading} />
      {activeTab === "Summary" ? (
        <>
          {timesheets.length > 0 && <div className="flex justify-end">
            <Button
              type="primary"
              className="bg-[#2EBAA3]"
              onClick={() => setDownloadPdfModalToggle(true)}
            >
              Download Pdf
            </Button>
          </div>}
          <div className="mt-8">
            <TimesheetInitial
              jobId={id}
              setShowTimesheetDetails={setShowTimesheetDetails}
              timesheets={timesheets}
              setTimesheets={setTimesheets}
            />
          </div>

          <Modal
            open={downloadPdfModalToggle}
            title={
              <span className="text-xl font-semibold">
                Download Timesheet Pdf
              </span>
            }
            onCancel={() => setDownloadPdfModalToggle(false)}
            footer={[
              <button
                className="text-white hover:font-medium"
                style={{
                  width: "200px",
                  height: "45px",
                  background: "#139588",
                  borderRadius: "4px",
                }}
                onClick={downloadPdf}
              >
                Download
              </button>,
            ]}
          >
            <p className="mt-3">Select Week</p>
            <Space wrap>
              <div className="flex flex-col gap-y-4">
                <RangePicker
                  format={"DD, MMM"}
                  onChange={(values) =>
                    values
                      ? setStartEndDate(
                        values.map((value) => dayjs(value).format("DD-MM-YYYY"))
                      )
                      : null
                  }
                />
                <div className="flex flex-row space-x-4 items-center">
                  <span className="text-xs max-w-[70px]">Detailed Timesheet</span>
                  <Switch className="w-8 bg-gray-600" checked={timesheetSummary} onChange={onChangeSummary} />
                  <span className="text-xs max-w-[70px]">Only Summary</span>
                </div>
              </div>
            </Space>
          </Modal>
        </>
      ) : (
        <Messages />
      )}
    </div>
  );
}
